import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChangeOperationalAreaMenuVisibilityRequest,
  ChangeOperationalAreaStatusRequest,
  CreateOperationalAreaRequest,
  OperationalArea,
  OperationalAreaStatus,
  UpdateOperationalAreaRequest,
} from '../contracts';

@Injectable({
  providedIn: 'root',
})
export class OperationalAreaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.urlApi}operational-areas`;

  //#region GET/BUSCA

  getAll(status?: OperationalAreaStatus, menuVisible?: boolean): Observable<OperationalArea[]> {
    let params = new HttpParams();

    if (status !== undefined) {
      params = params.set('status', status);
    }

    if (menuVisible !== undefined) {
      params = params.set('menuVisible', menuVisible);
    }

    return this.http.get<OperationalArea[]>(`${this.apiUrl}/get-all`, {
      params,
    });
  }

  getByAreaKey(areaKey: string): Observable<OperationalArea> {
    return this.http.get<OperationalArea>(
      `${this.apiUrl}/get-by-area-key/${encodeURIComponent(areaKey)}`,
    );
  }

  //#endregion

  //#region CREATE/CRIAR

  create(request: CreateOperationalAreaRequest): Observable<OperationalArea> {
    return this.http.post<OperationalArea>(`${this.apiUrl}/create`, request);
  }

  //#endregion

  //#region UPDATE/ATUALIZAR

  update(areaKey: string, request: UpdateOperationalAreaRequest): Observable<OperationalArea> {
    return this.http.put<OperationalArea>(
      `${this.apiUrl}/update/${encodeURIComponent(areaKey)}`,
      request,
    );
  }

  changeStatus(
    areaKey: string,
    request: ChangeOperationalAreaStatusRequest,
  ): Observable<OperationalArea> {
    return this.http.patch<OperationalArea>(
      `${this.apiUrl}/change-status/${encodeURIComponent(areaKey)}`,
      request,
    );
  }

  changeMenuVisibility(
    areaKey: string,
    request: ChangeOperationalAreaMenuVisibilityRequest,
  ): Observable<OperationalArea> {
    return this.http.patch<OperationalArea>(
      `${this.apiUrl}/change-menu-visibility/${encodeURIComponent(areaKey)}`,
      request,
    );
  }

  //#endregion

  //#region DELETE/DELETAR

  delete(areaKey: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${encodeURIComponent(areaKey)}`);
  }

  //#endregion
}
